import { LOGIN_SUCCESS, LOGIN_FAIL, LOGOUT, MFA_QR_CODE, MFA_ENABLE } from "../action/types";

const initialState = {
  isAuthenticated: null,
  loading: true,
  user: null,
  qrCodeUrl: null,
  mfaDeviceName: null,
  mfaToken: null
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case LOGIN_SUCCESS:

      return {
        ...state,
        ...payload,
        isAuthenticated: true,
        loading: false,
        token: payload.accessToken,
        mfaToken: null,
        qrCodeUrl: null,
        mfaDeviceName: null,
      };

    case MFA_QR_CODE:
      return {
        ...state,
        isAuthenticated: false,
        qrCodeUrl: payload.qrCodeUrl,
        mfaDeviceName: payload.deviceName || null,
        loading: false,
      };
    case MFA_ENABLE:
      return {
        ...state,
        mfaToken: payload.tokenId || payload.mfaToken || null,
      }
    case LOGIN_FAIL:
    case LOGOUT:
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loading: false,
        mfaToken: null,
        qrCodeUrl: null,
        mfaDeviceName: null,
      };

    default:
      return state;
  }
}
